module.exports = __webpack_public_path__ + "static/media/varm.176d5868.m4a";